const getPanelsWithComputation = (panels) => panels.filter(p => p.computation)

export default {
    async next({ dispatch, rootState }) {
      let panel = {}
      try {
        panel = await dispatch('nextPanel')
      }
      catch (e) {
        console.log(e)
      }
      return panel || {}
    },

    async nextPanel({ dispatch, rootState, rootGetters }) {
      const isNextPanelToEdit = (panel) => {
        const isAlreadyAnswered = panel.responses.some(r => r.selected === true)
        const isUploadNotReady = panel.input === 'upload' && !rootGetters['v4/collect/ready']
        const isObservationNotReady = panel.input === 'observation' && !rootGetters['v4/observation/ready']
      
        return !isAlreadyAnswered && !isUploadNotReady && !isObservationNotReady
      }

      let returnPanel = {}

      try {
        const track = rootState.v4.track.current
        const indexOfCurrentPanel = track.panels.findIndex(p => p.name === rootState.route.params.panels_name)
        let indexOfNextPanel = indexOfCurrentPanel + 1
        const currentPanel = track.panels[indexOfCurrentPanel]

        // if skipping to a panel, set index to that panel
        try {
          if (currentPanel?.actions?.skipTo) {
            const selectedResponseValue = currentPanel.responses.find(r => r.selected).value
            const skipToPanelName = currentPanel.actions.skipTo[selectedResponseValue]
            if (skipToPanelName) {
              indexOfNextPanel = track.panels.findIndex(p => p.name === skipToPanelName)
            }
          }
        } catch (e) { console.log(e) }

        if (rootGetters['v4/mode/get']('dontSkipPanels')) {
          returnPanel = track.panels[indexOfNextPanel]
        } else {
          // loop through future panels until we find one to return
          for (let i = indexOfNextPanel; i < track.panels.length; i++) {
            const panel = track.panels[i]
            const shouldSkip = await dispatch('shouldSkipPanel', panel)
            const inEditMode = rootGetters['v4/track/editResponsesMode']

            // if it's a computation panel, skip it
            if (panel.computation) {
              continue
            // if panel has skiplogic, clear it of any existing responses and continue to next panel
            } else if (shouldSkip) {
              await dispatch('reset', panel.name)
              continue
            // if not in edit mode, or if it is and this is the next panel to edit, return it
            } else if (!inEditMode || isNextPanelToEdit(panel)) {
              returnPanel = panel
              break
            }
          }
        }
      } catch (e) {
        console.log(e)
      }

      return returnPanel
    },

    async shouldSkipPanel( { dispatch }, panel) {
      let shouldSkip = false
      const hasDisplayActions = panel.actions && panel.actions.beforeDisplay

      if (hasDisplayActions) {
        shouldSkip = await dispatch(`actions/${panel.actions.beforeDisplay}`, panel)
      }
      if (panel.skipForStreamlined) {
        shouldSkip = true
      }

      return shouldSkip
    },

    set({ commit, getters }, payload) {
      let panel = getters.current
      commit('set', { panel: panel, responses: payload })
    },

    async reset({ commit, getters, rootGetters }, payload) {
      const track = rootGetters['v4/track/current']
      const panel = track.panels.find(p => p.name === payload)
      const responses = panel.responses.map(response => {
        response.selected = false
        if (panel.type === 'value') response.value = null
        return response
      })

      commit('set', { panel: panel, responses: responses })
    },

    async responses({ dispatch, rootGetters }, payload = {}) {
      const responses = rootGetters['v4/track/current'].panels.reduce((preppedResponses, panel) => {
        const panelWasAnswered = panel.responses.some(r => r.selected)
        if (!panel.computation && panelWasAnswered) {
          panel.responses.forEach(response => {
            preppedResponses.push({...response, panel: panel.name, type: panel.type, input: panel.input })
          })
        }
        return preppedResponses
      }, [])

      const preferences = dispatch('preferenceResponses')
      const computed = dispatch('computedResponses')
      const promised = await Promise.all([preferences, computed])
      const prepared = responses.concat(promised.flat())
      const results = await dispatch('v4/mrx/convert', prepared, { root: true })
      return results
    },

    async preferenceResponses({ getters, state, dispatch }) {
        let results = []
        try {
            let prefs = await dispatch('preferences')
            prefs.reduce((prefResponses, panel) => {
                if (!panel.computation) {
                    panel.responses.forEach(response => {
                        if (response.selected) {
                            prefResponses.push({...response, panel: panel.name, type: panel.type, input: panel.input })
                        }
                    })
                }
                return prefResponses
            }, results)
        }
        catch (e) { console.log(e) }
        return results
    },

    async preferences({ rootState }) {
        let results = []
        try {
            results = JSON.parse(JSON.stringify(rootState.preferences || []))
        }
        catch (e) { console.log(e) }
        return results
    },

    async computedResponses({ dispatch, rootGetters }) {
        let results = []
        try {
            let computed = getPanelsWithComputation(rootGetters['v4/track/current'].panels)
            results = computed.map(async panel => {
                let responses = await dispatch(`computed/${panel.computation}`, JSON.parse(JSON.stringify(panel.responses)))
                let selected = responses.find(r => r.selected) || responses[0]
                return {...selected, panel: panel.name, type: panel.type, input: panel.input }
            })
        }
        catch (e) { console.log(e) }
        return Promise.all(results)
    },
}
